module.exports = __webpack_public_path__ + "static/RedeyeA-728489b39c7788617b403b9575016426.gif";